(function () {
  if (window.__mysheepiKpiTrackerLoaded) return;
  window.__mysheepiKpiTrackerLoaded = true;

  var READ_MILESTONES = [15, 30, 60, 120];
  var SCROLL_MILESTONES = [25, 50, 75, 90];
  var IMPORTANT_EVENTS = {
    add_to_cart_intent: true,
    checkout_click: true,
    purchase_page_view: true,
    quick_exit: true,
    upsell_add_click: true,
    cross_sell_add_click: true,
    home_to_product: true,
    home_to_cart: true,
    home_to_checkout: true,
    header_home_icon_click: true,
    header_navigation_click: true,
  };

  var context = window.mysheepiKpiContext || {};
  var started = Date.now();
  var activeSeconds = 0;
  var maxScroll = 0;
  var lastEvents = {};
  var readFired = {};
  var scrollFired = {};
  var clarityQueue = [];
  var clarityRetries = 0;

  function clean(value, limit) {
    return String(value == null ? '' : value)
      .replace(/\s+/g, ' ')
      .replace(/[\r\n\t]/g, ' ')
      .trim()
      .slice(0, limit || 120);
  }

  function getPath(url) {
    try {
      return new URL(url || window.location.href, window.location.origin).pathname || '/';
    } catch (error) {
      return window.location.pathname || '/';
    }
  }

  function currentPath() {
    return getPath(window.location.href);
  }

  function pageTypeFromPath(path) {
    if (path === '/') return 'home';
    if (path.indexOf('/products/') === 0) return 'product';
    if (path.indexOf('/collections/') === 0) return 'collection';
    if (path.indexOf('/pages/') === 0) return 'page';
    if (path.indexOf('/blogs/') === 0) return 'content';
    if (path.indexOf('/cart') === 0) return 'cart';
    if (path.indexOf('/checkout') === 0 || path.indexOf('/checkouts/') === 0) return 'checkout';
    if (path.indexOf('/search') === 0) return 'search';
    return 'other';
  }

  function getLabel(element) {
    if (!element) return '';
    return clean(
      element.getAttribute('data-kpi-label') ||
        element.getAttribute('aria-label') ||
        element.getAttribute('title') ||
        element.innerText ||
        element.textContent ||
        element.value ||
        element.name ||
        element.id ||
        element.className,
      90
    );
  }

  function sameHost(url) {
    try {
      var parsed = new URL(url, window.location.origin);
      return parsed.hostname.replace(/^www\./, '') === window.location.hostname.replace(/^www\./, '');
    } catch (error) {
      return false;
    }
  }

  function pushDataLayer(name, payload) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: 'mysheepi_' + name }, payload));
  }

  function publishShopify(name, payload) {
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish('mysheepi_' + name, payload);
      }
    } catch (error) {}
  }

  function callClarity(method, args) {
    if (typeof window.clarity === 'function') {
      try {
        window.clarity.apply(window, [method].concat(args || []));
        return;
      } catch (error) {}
    }

    clarityQueue.push([method, args || []]);
    scheduleClarityFlush();
  }

  function flushClarity() {
    if (typeof window.clarity !== 'function') {
      scheduleClarityFlush();
      return;
    }

    var queue = clarityQueue.splice(0, clarityQueue.length);
    queue.forEach(function (item) {
      try {
        window.clarity.apply(window, [item[0]].concat(item[1]));
      } catch (error) {}
    });
  }

  function scheduleClarityFlush() {
    if (clarityRetries > 30) return;
    clarityRetries += 1;
    window.setTimeout(flushClarity, Math.min(5000, 250 * clarityRetries));
  }

  function setClarityTags(name, payload) {
    var tags = {
      event: name,
      page_type: payload.page_type,
      page_path: payload.page_path,
      template: payload.template,
      destination_type: payload.destination_type,
      engagement_level: payload.engagement_level,
      source: payload.source,
    };

    Object.keys(tags).forEach(function (key) {
      if (tags[key] != null && tags[key] !== '') {
        callClarity('set', ['mysheepi_' + key, clean(tags[key], 80)]);
      }
    });
  }

  function eventPayload(extra) {
    return Object.assign(
      {
        page_path: currentPath(),
        page_type: context.pageType || pageTypeFromPath(currentPath()),
        template: context.template || '',
        template_suffix: context.templateSuffix || '',
        active_seconds: activeSeconds,
        max_scroll_percent: maxScroll,
      },
      extra || {}
    );
  }

  function assignmentPayload(assignment) {
    if (!assignment) return {};

    return {
      experiment_id: clean(assignment.experimentId || '', 80),
      experiment_name: clean(assignment.experimentName || '', 120),
      experiment_variant_id: clean(assignment.variantId || '', 80),
      experiment_variant_name: clean(assignment.variantName || '', 120),
      experiment_source: clean(assignment.source || '', 80),
      experiment_mode: clean(assignment.mode || '', 40),
      experiment_active: assignment.active === true,
      experiment_surface: clean(assignment.surface || '', 80),
    };
  }

  function getAssignment(key) {
    var assignments = window.mysheepiAbAssignments || {};
    return assignments[key] || null;
  }

  function shouldReportHeaderNavigation(assignment) {
    return !!(
      assignment &&
      assignment.experimentId === 'header_navigation_2026_08' &&
      (assignment.active === true || assignment.source === 'forced_preview' || assignment.variantId === 'figma_nav')
    );
  }

  function elementExperimentPayload(element) {
    var key = element && element.getAttribute ? clean(element.getAttribute('data-kpi-experiment') || '', 80) : '';
    return key ? assignmentPayload(getAssignment(key)) : {};
  }

  function emit(name, extra, important) {
    var key = name + '|' + clean((extra && (extra.href || extra.label || extra.destination_path)) || '', 120);
    var now = Date.now();
    if (lastEvents[key] && now - lastEvents[key] < 700) return;
    lastEvents[key] = now;

    var payload = eventPayload(extra);
    payload.kpi_event = name;

    pushDataLayer(name, payload);
    publishShopify(name, payload);
    callClarity('event', ['mysheepi_' + name]);
    setClarityTags(name, payload);

    if (important || IMPORTANT_EVENTS[name]) {
      callClarity('upgrade', ['mysheepi_' + name]);
    }
  }

  function scrollPercent() {
    var doc = document.documentElement;
    var body = document.body;
    var height = Math.max(doc.scrollHeight, body ? body.scrollHeight : 0, doc.clientHeight);
    var viewport = window.innerHeight || doc.clientHeight || 1;
    var top = window.pageYOffset || doc.scrollTop || (body ? body.scrollTop : 0) || 0;
    if (height <= viewport) return 100;
    return Math.max(0, Math.min(100, Math.round(((top + viewport) / height) * 100)));
  }

  function updateScroll() {
    maxScroll = Math.max(maxScroll, scrollPercent());
    SCROLL_MILESTONES.forEach(function (milestone) {
      if (maxScroll >= milestone && !scrollFired[milestone]) {
        scrollFired[milestone] = true;
        emit('scroll_' + milestone, {
          engagement_level: 'scroll_' + milestone,
        });
      }
    });
  }

  function tickActiveTime() {
    if (document.visibilityState && document.visibilityState !== 'visible') return;
    activeSeconds += 1;

    READ_MILESTONES.forEach(function (seconds) {
      if (activeSeconds >= seconds && !readFired[seconds]) {
        readFired[seconds] = true;
        emit('read_' + seconds + 's', {
          engagement_level: 'read_' + seconds + 's',
        });
      }
    });
  }

  function classifyLink(url) {
    var path = getPath(url);
    var type = pageTypeFromPath(path);
    return {
      path: path,
      type: type,
      homeEvent: type === 'home' ? 'home_to_home' : 'home_to_' + type,
    };
  }

  function isAddToCart(element, label) {
    var form = element && element.closest ? element.closest('form') : null;
    var action = form ? form.getAttribute('action') || '' : '';
    return (
      /\/cart\/add/i.test(action) ||
      /product-form/i.test((element && element.closest && element.closest('product-form') && 'product-form') || '') ||
      /add to cart|in den warenkorb|warenkorb hinzuf|zum warenkorb/i.test(label)
    );
  }

  function isCheckout(element, label, destinationPath) {
    return (
      /checkout|checkouts|zur kasse|\bkasse\b/i.test(label) ||
      /\/checkout|\/checkouts\//i.test(destinationPath || '') ||
      clean(element && (element.id || element.name), 80).toLowerCase() === 'checkout'
    );
  }

  function offerPayload(element, basePayload) {
    var offer = element && element.closest ? element.closest('[data-kpi-offer]') : null;
    if (!offer) return null;
    var offerType = clean(offer.getAttribute('data-kpi-offer') || 'upsell', 40).replace(/-/g, '_');
    return Object.assign({}, basePayload || {}, {
      offer_type: offerType,
      offer_surface: clean(offer.getAttribute('data-kpi-surface') || '', 80),
      product_id: clean(offer.getAttribute('data-kpi-product-id') || offer.getAttribute('data-product-id') || '', 80),
      product_title: clean(offer.getAttribute('data-kpi-product-title') || '', 120),
      variant_id: clean(element.getAttribute('data-variant-id') || element.value || '', 80),
    });
  }

  function emitOfferClick(target, payload, label, href) {
    var offer = offerPayload(target, payload);
    if (!offer) return false;
    var prefix = offer.offer_type === 'cross_sell' ? 'cross_sell' : 'upsell';
    if (isAddToCart(target, label)) {
      emit(prefix + '_add_click', offer, true);
      emit('add_to_cart_intent', offer, true);
      return true;
    }
    if (href) {
      emit(prefix + '_product_click', offer);
      return true;
    }
    emit(prefix + '_click', offer);
    return true;
  }

  function handleClick(event) {
    var target = event.target && event.target.closest
      ? event.target.closest('[data-kpi-event], a[href], button, input[type="button"], input[type="submit"], [role="button"], summary')
      : null;
    if (!target) return;

    var label = getLabel(target);
    var link = target.matches && target.matches('a[href]') ? target : target.closest && target.closest('a[href]');
    var href = link ? link.getAttribute('href') : '';
    var destination = href ? classifyLink(href) : { path: '', type: '' };
    var payload = {
      label: label,
      href: href ? clean(href, 160) : '',
      destination_path: destination.path || '',
      destination_type: destination.type || '',
      source: 'click',
    };
    payload = Object.assign(payload, elementExperimentPayload(target));
    var customName = target.getAttribute('data-kpi-event');
    var current = currentPath();
    var headerNavigationAssignment = target.closest && target.closest('header.header')
      ? getAssignment('headerNavigation')
      : null;

    if (emitOfferClick(target, payload, label, href)) {
      // Offer-specific clicks still flow through the normalized KPI stream.
    } else if (customName) {
      emit(clean(customName, 50).replace(/\s+/g, '_').toLowerCase(), payload, true);
    } else if (isCheckout(target, label, destination.path)) {
      emit('checkout_click', payload, true);
    } else if (isAddToCart(target, label)) {
      emit('add_to_cart_intent', payload, true);
    } else if (/newsletter|klaviyo/i.test(label)) {
      emit('newsletter_click', payload);
    } else if (/quiz|beratung|schlafberatung/i.test(label + ' ' + destination.path)) {
      emit('consultation_click', payload, true);
    } else if (destination.type === 'product') {
      emit('product_click', payload);
    } else if (destination.type === 'collection') {
      emit('collection_click', payload);
    } else if (target.matches('button, input[type="button"], input[type="submit"], [role="button"]')) {
      emit('button_click', payload);
    } else if (link && /button|btn|cta|fh-button/i.test(link.className || '')) {
      emit('cta_click', payload);
    }

    if (current === '/' && href && sameHost(href) && destination.type && destination.type !== 'home') {
      emit(destination.homeEvent, payload, IMPORTANT_EVENTS[destination.homeEvent]);
    }

    if (shouldReportHeaderNavigation(headerNavigationAssignment)) {
      emit(
        'header_navigation_click',
        Object.assign({}, payload, assignmentPayload(headerNavigationAssignment)),
        true
      );
    }
  }

  function handleSubmit(event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches('form')) return;

    var action = form.getAttribute('action') || '';
    var label = getLabel(form) || clean(form.id || form.className || action, 90);
    if (/\/cart\/add/i.test(action)) {
      emit('add_to_cart_intent', { label: label, source: 'form_submit' }, true);
    } else if (/newsletter|klaviyo/i.test(label + ' ' + action)) {
      emit('newsletter_submit', { label: label, source: 'form_submit' }, true);
    } else if (/search/i.test(action)) {
      emit('search_submit', { label: label, source: 'form_submit' });
    } else {
      emit('form_submit', { label: label, source: 'form_submit' });
    }
  }

  function handleEnd() {
    updateScroll();
    if (activeSeconds < 10 && maxScroll < 25) {
      emit('quick_exit', {
        engagement_level: 'quick_exit',
        seconds_on_page: Math.round((Date.now() - started) / 1000),
      }, true);
      return;
    }

    if (activeSeconds >= 30 && maxScroll >= 50) {
      emit('engaged_visit', {
        engagement_level: 'engaged_visit',
      });
    }
  }

  function initOfferImpressions() {
    var offers = Array.prototype.slice.call(document.querySelectorAll('[data-kpi-offer]'));
    if (!offers.length) return;
    var seen = {};
    function mark(offer) {
      var key = offer.getAttribute('data-kpi-offer-key') ||
        offer.getAttribute('data-kpi-product-id') ||
        offer.getAttribute('data-product-id') ||
        offer.textContent;
      key = clean(key, 120);
      if (!key || seen[key]) return;
      seen[key] = true;
      var offerType = clean(offer.getAttribute('data-kpi-offer') || 'upsell', 40).replace(/-/g, '_');
      var prefix = offerType === 'cross_sell' ? 'cross_sell' : 'upsell';
      emit(prefix + '_impression', offerPayload(offer, { source: 'impression' }) || { source: 'impression' });
    }
    if (!('IntersectionObserver' in window)) {
      offers.forEach(mark);
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting || entry.intersectionRatio > 0.35) {
          mark(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: [0.35] });
    offers.forEach(function (offer) { observer.observe(offer); });
  }

  function initAbImpressions() {
    var assignments = window.mysheepiAbAssignments || {};

    Object.keys(assignments).forEach(function (key) {
      var assignment = assignments[key];

      if (!assignment || assignment.reported === true) return;

      assignment.reported = true;

      var payload = Object.assign(assignmentPayload(assignment), {
        source: 'impression',
      });

      if (assignment.active === true) {
        emit('ab_impression', payload);
      }

      if (assignment.show === true && assignment.experimentId === 'header_home_icon_2026_08') {
        emit('header_home_icon_impression', payload);
      }

      if (shouldReportHeaderNavigation(assignment)) {
        emit('header_navigation_impression', payload);
      }
    });
  }

  function init() {
    updateScroll();
    emit('page_view', {
      product_handle: context.productHandle || '',
      collection_handle: context.collectionHandle || '',
      page_handle: context.pageHandle || '',
      source: 'page_load',
    });

    if (/thank_you|\/orders\//i.test(window.location.pathname)) {
      emit('purchase_page_view', { source: 'page_load' }, true);
    }

    document.addEventListener('click', handleClick, true);
    document.addEventListener('submit', handleSubmit, true);
    initAbImpressions();
    initOfferImpressions();
    window.addEventListener('scroll', updateScroll, { passive: true });
    window.addEventListener('resize', updateScroll);
    window.addEventListener('pagehide', handleEnd);
    window.setInterval(tickActiveTime, 1000);
    scheduleClarityFlush();
  }

  function boot() {
    if (window.mysheepiConsent && typeof window.mysheepiConsent.onAny === 'function') {
      window.mysheepiConsent.onAny(['analytics', 'performance'], init);
      return;
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  }

  boot();
})();
